'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002ecrud$0024$002dDelete$002dDialog from "./presto.crud$-Delete-Dialog.js";
import * as $j_presto$002etypes$0024proto$0024$002dDelete$002dGroup$002dRequest from "./presto.types$proto$-Delete-Group-Request.js";
var $p;
/** @constructor */
function $c_Lpresto_DeleteGroupView(group) {
  this.aLI = null;
  this.a7R = null;
  this.aLI = group;
  this.a7R = new $j_presto$002ecrud$0024$002dDelete$002dDialog.$c_Lpresto_crud$DeleteDialog("remover grupo");
}
export { $c_Lpresto_DeleteGroupView as $c_Lpresto_DeleteGroupView };
$p = $c_Lpresto_DeleteGroupView.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_DeleteGroupView;
/** @constructor */
function $h_Lpresto_DeleteGroupView() {
}
export { $h_Lpresto_DeleteGroupView as $h_Lpresto_DeleteGroupView };
$h_Lpresto_DeleteGroupView.prototype = $p;
$p.bR = (function() {
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$();
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_airstream_state_Val$().au(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success(new $j_presto$002etypes$0024proto$0024$002dDelete$002dGroup$002dRequest.$c_Lpresto_types$proto$DeleteGroupRequest(this.aLI.fR)));
});
$p.bP = (function() {
  return this.a7R.mY;
});
$p.bE = (function() {
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$();
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_airstream_state_Val$().au(this.a7R.b2());
});
var $d_Lpresto_DeleteGroupView = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_DeleteGroupView, "presto.DeleteGroupView", ({
  H0: 1,
  J: 1
}));
export { $d_Lpresto_DeleteGroupView as $d_Lpresto_DeleteGroupView };
//# sourceMappingURL=presto.-Delete-Group-View.js.map
